
import { trendingResources } from './trendingResources';

// Helper to find resources from the big list
const findResources = (query) => {
  const lowerQuery = query.toLowerCase();
  return trendingResources.filter(r => 
    r.title.toLowerCase().includes(lowerQuery) || 
    r.description.toLowerCase().includes(lowerQuery)
  ).slice(0, 3);
};

const domains = {
  Technology: {
    "Artificial Intelligence": {
      description: "Artificial Intelligence (AI) is the simulation of human intelligence processes by machines, especially computer systems. It involves learning, reasoning, and self-correction.",
      careerOutlook: "High demand in every sector from healthcare to finance. Roles include AI Engineer, Research Scientist, and Data Analyst.",
      salaryRange: "$120k - $250k+",
      roadmap: [
        { phase: "Foundations", items: ["Python Programming", "Linear Algebra & Statistics", "Data Structures"] },
        { phase: "Core Concepts", items: ["Machine Learning Algorithms", "Neural Networks", "Deep Learning"] },
        { phase: "Advanced", items: ["NLP", "Computer Vision", "Reinforcement Learning"] }
      ],
      relatedSkills: ["Python", "TensorFlow", "PyTorch", "Data Science", "Mathematics"],
      docs: [
        { title: "TensorFlow Documentation", url: "https://www.tensorflow.org/learn" },
        { title: "PyTorch Tutorials", url: "https://pytorch.org/tutorials/" },
        { title: "Scikit-learn", url: "https://scikit-learn.org/stable/" }
      ]
    },
    "Generative AI / LLMs": {
        description: "Generative AI refers to algorithms (such as ChatGPT) that can be used to create new content, including audio, code, images, text, simulations, and videos.",
        careerOutlook: "Explosive growth. Companies are rushing to integrate LLMs. Roles: Prompt Engineer, AI Ethicist, LLM Developer.",
        salaryRange: "$130k - $300k+",
        roadmap: [
            { phase: "Basics", items: ["Python", "NLP Fundamentals", "Transformer Architecture"] },
            { phase: "Applied GenAI", items: ["OpenAI API", "LangChain", "Hugging Face"] },
            { phase: "Fine-tuning", items: ["PEFT/LoRA", "RLHF", "Model Evaluation"] }
        ],
        relatedSkills: ["NLP", "Python", "Deep Learning", "Cloud Computing"],
        docs: [
            { title: "LangChain Docs", url: "https://python.langchain.com/docs/get_started/introduction" },
            { title: "Hugging Face Course", url: "https://huggingface.co/learn/nlp-course" },
            { title: "OpenAI API", url: "https://platform.openai.com/docs/introduction" }
        ]
    }
  }
};

// Generic fallback generator for skills not explicitly detailed
const generateGenericData = (domain, skillName) => {
    const resources = findResources(skillName.split(' ')[0]) || []; 
    // If no resources found, grab some random ones from the domain if possible, or just generic tech ones
    
    return {
        description: `${skillName} is a critical skill in the ${domain} sector, driving innovation and efficiency. Professionals with this skill are highly sought after.`,
        careerOutlook: `Growing demand in ${domain}. Opportunities are expanding as industries adopt digital transformation.`,
        salaryRange: "$80k - $180k",
        roadmap: [
            { phase: "Fundamentals", items: [`Intro to ${skillName}`, "Core Principles", "Tools & Envrionment"] },
            { phase: "Intermediate", items: ["Advanced Techniques", "Real-world Projects", "Best Practices"] },
            { phase: "Expert", items: ["System Design", "Optimization", "Leadership"] }
        ],
        relatedSkills: [`Advanced ${skillName}`, "Project Management", "Data Analysis"], 
        docs: [
            { title: `${skillName} Official Docs`, url: `https://www.google.com/search?q=${skillName}+documentation` },
            { title: "Community Guide", url: `https://www.google.com/search?q=${skillName}+guide` }
        ],
        resources: resources.length > 0 ? resources : [
             { id: 'gen1', title: `Learn ${skillName} from Scratch`, description: "A comprehensive guide to mastering this skill.", link: "#", image: "https://via.placeholder.com/150", category: "Guide" }
        ]
    };
};

export const getSkillDetails = (domain, skillName) => {
    // Navigate the structure
    const domainData = domains[domain];
    if (domainData && domainData[skillName]) {
        // Merge with resources if not manually specified
        const data = domainData[skillName];
        if (!data.resources) {
            data.resources = findResources(skillName.split(' ')[0]);
        }
        return data;
    }
    
    return generateGenericData(domain, skillName);
};
